/* GENERATED by scripts/experience/generate-design-tokens.ts. DO NOT EDIT. */
export const EXPERIENCE_NATIVE_TOKENS = {
  schemaVersion: '1.0.0-candidate.1',
  adapterVersion: '1.0.0-candidate.1',
  colours: {
    light: {
      'identity.statura.decorative': '#96A998',
      'identity.statura.foreground': '#3E5D4A',
      'identity.tenant.fallback': '#3E5D4A',
      'surface.canvas': '#F8FAFC',
      'surface.base': '#FFFFFF',
      'surface.subtle': '#F5F6F2',
      'surface.inverse': '#0F172A',
      'text.primary': '#1E293B',
      'text.secondary': '#475569',
      'text.body': '#334155',
      'text.muted': '#64748B',
      'text.inverse': '#FFFFFF',
      'border.default': '#CBD5E1',
      'border.strong': '#64748B',
      'focus.ring': '#3E5D4A',
      'status.danger': '#B91C1C',
      'status.warning': '#B45309',
      'status.success': '#15803D',
      'status.information': '#1D4ED8',
      'workflow.approval': '#6D28D9',
      'domain.finance': '#0369A1',
      'program.sah': '#0F766E',
      'program.rac': '#7E22CE',
    },
    dark: {
      'identity.statura.decorative': '#AFC1B1',
      'identity.statura.foreground': '#C5D6C7',
      'identity.tenant.fallback': '#C5D6C7',
      'surface.canvas': '#0F172A',
      'surface.base': '#1E293B',
      'surface.subtle': '#273449',
      'surface.inverse': '#FFFFFF',
      'text.primary': '#F8FAFC',
      'text.secondary': '#CBD5E1',
      'text.body': '#E2E8F0',
      'text.muted': '#94A3B8',
      'text.inverse': '#0F172A',
      'border.default': '#64748B',
      'border.strong': '#CBD5E1',
      'focus.ring': '#C5D6C7',
      'status.danger': '#FCA5A5',
      'status.warning': '#FCD34D',
      'status.success': '#86EFAC',
      'status.information': '#93C5FD',
      'workflow.approval': '#C4B5FD',
      'domain.finance': '#7DD3FC',
      'program.sah': '#5EEAD4',
      'program.rac': '#D8B4FE',
    },
    highContrast: {
      'identity.statura.decorative': '#000000',
      'identity.statura.foreground': '#000000',
      'identity.tenant.fallback': '#000000',
      'surface.canvas': '#FFFFFF',
      'surface.base': '#FFFFFF',
      'surface.subtle': '#FFFFFF',
      'surface.inverse': '#000000',
      'text.primary': '#000000',
      'text.secondary': '#111111',
      'text.body': '#000000',
      'text.muted': '#1A1A1A',
      'text.inverse': '#FFFFFF',
      'border.default': '#000000',
      'border.strong': '#000000',
      'focus.ring': '#005FCC',
      'status.danger': '#B00020',
      'status.warning': '#7A3E00',
      'status.success': '#006B2E',
      'status.information': '#0039A6',
      'workflow.approval': '#4A148C',
      'domain.finance': '#004B73',
      'program.sah': '#005A52',
      'program.rac': '#5E168F',
    },
  },
  typography: {
    display: {
      family: 'display',
      fontSize: 44,
      lineHeight: 48,
      letterSpacing: -0.44,
      fontWeight: '700',
      constrainedChannelWeight: 700,
    },
    pageTitle: {
      family: 'display',
      fontSize: 30,
      lineHeight: 35,
      letterSpacing: 0,
      fontWeight: '700',
      constrainedChannelWeight: 700,
    },
    sectionTitle: {
      family: 'display',
      fontSize: 22,
      lineHeight: 28,
      letterSpacing: 0,
      fontWeight: '700',
      constrainedChannelWeight: 700,
    },
    cardTitle: {
      family: 'interface',
      fontSize: 17,
      lineHeight: 23,
      letterSpacing: 0,
      fontWeight: '600',
      constrainedChannelWeight: 600,
    },
    bodyLarge: {
      family: 'interface',
      fontSize: 18,
      lineHeight: 29,
      letterSpacing: 0,
      fontWeight: '400',
      constrainedChannelWeight: 400,
    },
    body: {
      family: 'interface',
      fontSize: 16,
      lineHeight: 24,
      letterSpacing: 0,
      fontWeight: '400',
      constrainedChannelWeight: 400,
    },
    bodySmall: {
      family: 'interface',
      fontSize: 14,
      lineHeight: 21,
      letterSpacing: 0,
      fontWeight: '400',
      constrainedChannelWeight: 400,
    },
    caption: {
      family: 'interface',
      fontSize: 12,
      lineHeight: 17,
      letterSpacing: 0,
      fontWeight: '500',
      constrainedChannelWeight: 500,
    },
    eyebrow: {
      family: 'interface',
      fontSize: 11,
      lineHeight: 13,
      letterSpacing: 0.44,
      fontWeight: '600',
      constrainedChannelWeight: 600,
    },
    metric: {
      family: 'interface',
      fontSize: 28,
      lineHeight: 31,
      letterSpacing: 0,
      fontWeight: '700',
      constrainedChannelWeight: 700,
    },
  },
  families: {
    display: {
      name: 'Merriweather',
      fallbackStack: ['Georgia', 'Times New Roman', 'serif'],
    },
    interface: {
      name: 'Space Grotesk',
      fallbackStack: ['Inter', 'system-ui', 'sans-serif'],
    },
  },
  motion: {
    fullMotion: {
      durations: {
        immediate: '0ms',
        fast: '150ms',
        normal: '200ms',
        deliberate: '500ms',
      },
      easing: {
        productive: 'ease-out',
      },
      allowDecorativeMotion: true,
    },
    reducedMotion: {
      durations: {
        immediate: '0ms',
        fast: '0ms',
        normal: '0ms',
        deliberate: '0ms',
      },
      easing: {
        productive: 'linear',
      },
      allowDecorativeMotion: false,
    },
  },
} as const;
